import { setupSGWTConnect } from '@sgwt/connect-core';
import { getConfig } from '@/config/config.ts';

const sgConnectConfig = getConfig().sgconnect;
const overrideClientId = sessionStorage.getItem('overrideClientId');

if (overrideClientId) {
  sgConnectConfig.client_id = overrideClientId;
}

export const sgwtConnect = setupSGWTConnect(sgConnectConfig);

export function getAuthorizationHeader(): string | null {
  return sgwtConnect.getAuthorizationHeader();
}

export function getAuthorizationToken(): string | undefined {
  const authorizationHeader = getAuthorizationHeader();
  if (authorizationHeader == null) {
    return undefined;
  }
  return authorizationHeader.replace('Bearer ', '');
}

export function getE2eClientIdPersona(): string | undefined {
  return getQueryParamFromUrl('E2eClientIdPersona');
}

export function getQueryParamFromUrl(queryParam: string): string | undefined {
  const params = new URLSearchParams(self.location.search);
  return (params.has(queryParam) && params.get(queryParam)) || undefined;
}
